import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { Select as AntdSelect } from 'antd';
import CircularLoader from 'components/CircularLoader';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { sizes } from 'components/Typography/Text';

const SelectField = ({ isLoading, options, dropDivide, ...props }, ref) => {
  return (
    <FormControl fullWidth size={props?.size}>
      {props?.label && (
        <InputLabel id={`custome-select-${props?.label || props?.placeholder}`}>
          {props.label}
        </InputLabel>
      )}
      <StyledSelect
        labelId={`custome-select-${props?.label || props?.placeholder}`}
        id='demo-simple-select'
        // IconComponent={<ExpandMoreIcon />}
        ref={ref}
        SelectProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <Stack direction='row' gap='2'>
                <ExpandMoreIcon />
                {props?.value && props?.allowClear && (
                  <div className='select-clear'>
                    <IconButton
                      size='small'
                      onClick={(evt) => {
                        evt.stopPropagation();
                        props?.onChange('');
                      }}
                    >
                      <ClearIcon
                        sx={{
                          width: '12px',
                          height: '12px'
                        }}
                        size='small'
                      />
                    </IconButton>
                  </div>
                )}
              </Stack>
            </InputAdornment>
          ),
          IconComponent: isLoading
            ? () => (
                <div style={{ marginRight: '1rem' }}>
                  <CircularLoader
                    color={'#545454'}
                    size={'16px'}
                    show={isLoading}
                  />
                </div>
              )
            : KeyboardArrowDownIcon,
          renderValue: (selected) => {
            if (selected.length === 0 || options.length < 1) {
              return <em>{props.placeholder ?? 'select'}</em>;
            }

            return (
              options?.find((el) => el.value === selected)?.label ?? selected
            );
          },
          MenuProps: {
            sx: {
              marginTop: '0.5rem !important',
              '& > div:first-of_type': {
                border: '1px solid #e1e1e1 !important',
                backgroundColor: ' !important'
              },
              '& ul': {
                paddingBlock: '0px !important'
              },
              '& li': {
                fontFamily: 'var(--black-family) !important',
                paddingBlock: '.5rem',
                fontSize: !props.textSize
                  ? 'initial'
                  : sizes[props?.textSize] ?? props?.textSize
              },
              ...(dropDivide
                ? {
                    '& li:not(:last-child)': {
                      borderBottom: '1px solid #E1e1e1 !important'
                    }
                  }
                : {})
            }
          }
        }}
        {...props}
      >
        {options?.map((option) => (
          <MenuItem value={option.value}>{option.label}</MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

export default forwardRef(SelectField);

const StyledSelect = styled(Select)`
  && {
    font-family: var(--black-family) !important;
    border-radius: 12px;
    position: relative;

    .select-clear {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

export const AntSelect = (props) => {
  return (
    <StyledAntSelect
      size='large'
      allowClear
      placeholder={props.placeholder}
      {...props}
    />
  );
};

const StyledAntSelect = styled(AntdSelect)`
  && {
    border-radius: 4px;
    min-width: 120px;
    font-family: var(--black-family) !important;
    & .ant-select-selector {
      border-radius: ${(props) => props.rounded ?? '8px'};
      border-color: rgba(168, 168, 168, 0.7) !important;
      &:hover {
        border-color: black !important;
      }
      &:focus {
        border-color: black !important;
        border-width: 2px !important;
      }
    }
    .ant-select-focus .ant-select-selector {
      border-color: black !important;
      &:hover {
        border-color: black !important;
      }
      &:focus {
        border-color: black !important;
      }
    }
    ${(props) => props.css ?? ''}
  }
`;
